import { Component } from "javascripts/lib/component";
import { StoreLayout } from "javascripts/layouts/store_layout";
import { ProductList } from 'javascripts/store/components/product_list';

Component.load(class extends StoreLayout {
  didLoad() {
    super.didLoad();
    new ProductList('product-list', { page: this.data.page }).init();
  }
});
